/* Bagsandlove – Bewertungs-Laufband
   Jede Karte wird einzeln verschoben und läuft links raus → rechts wieder rein.
   (Ein einziger, sehr breiter bewegter Streifen wird von Handy-Browsern nicht
   vollständig gezeichnet – dann entstehen weiße Lücken.)
   Tempo: Sekunden, die eine Karte durchs Bild braucht – für Handy und Desktop getrennt einstellbar.
   Tippen/Klicken hält an und startet wieder, Maus darüber hält kurz an. */
if (!customElements.get('bl-review-marquee')) {
  customElements.define(
    'bl-review-marquee',
    class BlReviewMarquee extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.bl-rm__list');
        this.toggle = this.querySelector('.bl-rm__toggle');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.offset = 0;
        this.paused = false;
        this.hovering = false;
        this.visible = false;

        this.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          this.setPaused(!this.paused);
        });

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.classList.add('is-js');

        // Nur eine echte Maus hält beim Drüberfahren an. Handys melden beim Antippen ebenfalls
        // „Maus darüber“ – ohne diese Prüfung ließe sich das Band per Tippen nicht wieder starten.
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.hovering = true;
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.hovering = false;
        });

        this.measure();
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this);

        this.intersection = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.start();
        });
        this.intersection.observe(this);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.intersection?.disconnect();
      }

      /* Sekunden, die eine Karte durchs Bild braucht – je nach Bildschirmbreite */
      get seconds() {
        const mobile = Number(this.dataset.secondsMobile);
        const desktop = Number(this.dataset.seconds);
        return (this.mobileQuery.matches ? mobile || desktop : desktop) || 14;
      }

      setPaused(paused) {
        this.paused = paused;
        this.classList.toggle('is-paused', paused);
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? this.dataset.pausedLabel : this.dataset.runningLabel);
      }

      /* Positionen der Karten merken; bei zu wenigen Karten Kopien anhängen, damit keine Lücke entsteht */
      measure() {
        this.list.querySelectorAll('.bl-rm__card.is-clone').forEach((c) => c.remove());
        const originals = [...this.list.querySelectorAll('.bl-rm__card')];
        if (!originals.length) return;

        const width = this.clientWidth;
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const cardWidth = originals[0].offsetWidth;
        const setWidth = originals.length * (cardWidth + gap);
        const copies = Math.max(0, Math.ceil((width + cardWidth) / setWidth) - 1);
        for (let i = 0; i < copies; i++) {
          originals.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.classList.add('is-clone');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            this.list.appendChild(clone);
          });
        }

        this.cards = [...this.list.querySelectorAll('.bl-rm__card')];
        this.cardWidth = cardWidth;
        this.loopWidth = this.cards.length * (cardWidth + gap);
        this.speed = width / this.seconds; // Pixel pro Sekunde (Handy/Desktop getrennt einstellbar)
        this.positions = this.cards.map((_, i) => i * (cardWidth + gap));
        this.render();
      }

      start() {
        cancelAnimationFrame(this.frame);
        let last = performance.now();
        const tick = (now) => {
          this.step(Math.min(0.1, (now - last) / 1000));
          last = now;
          if (this.visible) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }

      /* Ein Bewegungsschritt um dt Sekunden */
      step(dt) {
        if (this.paused || this.hovering || !this.loopWidth) return;
        this.offset = (this.offset + this.speed * dt) % this.loopWidth;
        this.render();
      }

      render() {
        if (!this.cards) return;
        const loop = this.loopWidth;
        this.cards.forEach((card, i) => {
          // Position im Kreis: Karte läuft links ganz hinaus, bevor sie rechts wieder auftaucht
          let x = (this.positions[i] - this.offset) % loop;
          if (x < -this.cardWidth) x += loop;
          card.style.transform = `translate3d(${x - this.positions[i]}px, 0, 0)`;
        });
      }
    }
  );
}
